import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=585a4308&scoped=true&lang=pug&"
import script from "./Birthdays.vue?vue&type=script&lang=js&"
export * from "./Birthdays.vue?vue&type=script&lang=js&"
import style0 from "./Birthdays.vue?vue&type=style&index=0&id=585a4308&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a4308",
  null
  
)

export default component.exports